<template>
  <div id="global_container">
    <div id="label">Mode {{ userTheme === "light-theme" ? "clair" : "sombre" }}</div>
    <div id="button_container">
      <div id="toggle-button">
        <input
            @change="toggleTheme"
            type="checkbox"
            id="toggle"
            class="toggle--checkbox">
        <label for="toggle" class="toggle--label">
      <span
          class="toggle--label-background"
          :class="{ 'switch-toggle-checked': userTheme === 'dark-theme' }"
      ></span>
        </label>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: "DarkLightModeButton",
    data() {
      return {
        userTheme: "light-theme",
      }
    },
    methods: {
      setTheme(theme) {
        localStorage.setItem("user-theme", theme)
        this.userTheme = theme
        document.documentElement.className = theme
      },
      toggleTheme() {
        const activeTheme = localStorage.getItem("user-theme")
        this.setTheme(activeTheme === 'light-theme' ? 'dark-theme' : 'light-theme')
      },
      getMediaPreference() {
        const hasDarkPreference = localStorage.getItem("user-theme")
        return hasDarkPreference || 'light-theme'
      }
    },
    mounted() {
      // set the user preference if it has been saved
      const checkbox = document.getElementById('toggle')
      if (this.getMediaPreference() === 'dark-theme') checkbox.checked = true
      this.setTheme(this.getMediaPreference())
    }
  }
</script>


<style scoped>
  #global_container {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }
  #button_container {
    height: 30px;
    width: 53px;
    overflow: hidden;
  }
  #label {
    margin-bottom: 6px;
  }
  #toggle-button {
    transform: translate(-50%, -50%) scale(.25) translate(50%, 50%);
  }

  .toggle--checkbox {
    display: none;
  }
  .toggle--checkbox:checked + .toggle--label {
    background: #1a223b;
    border-color: #66708d;
  }
  .toggle--checkbox:checked + .toggle--label .toggle--label-background {
    left: 60px;
    width: 5px;
  }
  .toggle--checkbox:checked + .toggle--label .toggle--label-background:before {
    width: 5px;
    height: 5px;
    top: -25px;
  }
  .toggle--checkbox:checked + .toggle--label .toggle--label-background:after {
    width: 5px;
    height: 5px;
    left: -30px;
    top: 20px;
  }
  .toggle--checkbox:checked + .toggle--label:before {
    background: #cecece;
    border-color: #bababa;
    animation-name: switch;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }
  .toggle--checkbox:checked + .toggle--label:after {
    transition-delay: .2s;
    opacity: 1;
  }
  .toggle--label {
    /** Placeholder element, starting at blue **/
    cursor: pointer;
    width: 200px;
    height: 100px;
    background: #addadc;
    border-radius: 100px;
    border: 4px solid #7abacb;
    display: flex;
    position: relative;
    transition: all .2s ease-in;
  }
  .toggle--label-background {
    width: 10px;
    height: 5px;
    border-radius: 5px;
    position: relative;
    background: #ffffff;
    left: 135px;
    top: 45px;
    transition: all .2s ease-in;
  }
  .toggle--label-background:before {
    content: "";
    position: absolute;
    top: -5px;
    width: 40px;
    height: 5px;
    border-radius: 5px;
    background: #ffffff;
    left: -20px;
    transition: all .2s ease-in;
  }
  .toggle--label-background:after {
    content: "";
    position: absolute;
    top: 5px;
    width: 40px;
    height: 5px;
    border-radius: 5px;
    background: #ffffff;
    left: -10px;
    transition: all .2s ease-in;
  }
  .toggle--label:before {
    animation-name: reverse;
    animation-duration: .2s;
    animation-fill-mode: forwards;
    transition: all .2s ease-in;
    content: "";
    width: 82px;
    height: 82px;
    border: 5px solid #eed559;
    top: 4px;
    left: 4px;
    position: absolute;
    border-radius: 82px;
    background: #fcd563;
  }
  .toggle--label:after {
    transition-delay: 0ms;
    transition: all 250ms ease-in;
    position: absolute;
    content: "";
    box-shadow: #ffffff -13px 0 0 2px, #ffffff -24px 14px 0 -2px;
    left: 143px;
    top: 23px;
    width: 10px;
    height: 10px;
    background: transparent;
    border-radius: 50%;
    opacity: 0;
  }

  @keyframes switch {
    0% {
      left: 4px;
    }
    60% {
      left: 4px;
      width: 112px;
    }
    100% {
      left: 104px;
      width: 82px;
    }
  }
  @keyframes reverse {
    0% {
      left: 104px;
      width: 82px;
    }
    60% {
      left: 72px;
      width: 112px;
    }
    100% {
      left: 4px;
    }
  }

  @media screen and (max-width: 720px) {
    #button_container {
      height: 22px;
      width: 42px;
    }
    #toggle-button {
      transform: translate(-50%, -50%) scale(.2) translate(50%, 50%);
    }
  }

</style>